module.exports = __webpack_public_path__ + "img/philippines.dd45b2e2.png";